<template>
    <div class="flex-none avatar flex items-center justify-center" :style="getStyle()">
        {{ userInitials }}
    </div>
</template>

<style scoped>
    .avatar {
        color: white;
        border-radius: 50%;
        overflow: hidden;
        line-height: 1;
        font-weight: 600;
    }
</style>

<script lang="ts">
import { session } from '@/globals/session';
import { Account } from '@/services/accounts';
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        account: Object,
        size: {
            type: String,
            default: '48px',
        },
        fontSize: {
            type: String,
            default: '20px',
        },
    },
    computed: {
        fullName(): string {
            const account = this.getAccount();
            if (account.full_name) return account.full_name;

            return account.first_name + ' ' + account.last_name;
        },
        userInitials() {
            let result = "";
            for (const namePart of this.fullName.split(" ")) result += namePart[0];
            return result
        }
    },
    methods: {
        stringToHslColor(id: string, s: number, l: number) {
            let hash = 0;
            for (let i = 0; i < id.length; i++) {
                hash = id.charCodeAt(i) + ((hash << 5) - hash);
            }

            const h = hash % 360;
            return 'hsl('+h+', '+s+'%, '+l+'%)';
        },
         getAccount(): Account {
            if (this.account) return this.account;
            return session.getAccount();
        },
        getStyle() {
            return {
                width: this.size,
                height: this.size,
                'font-size': this.fontSize,
                background: this.stringToHslColor(this.getAccount().id, 30, 70),
            }
        }
    }
});
</script>
